angular.module('tradersyard').controller('request-query-ctrl', [
    '$scope',
    'RequestManagerFactory',
    '$flex',
    function ($scope, RequestManagerFactory, $flex) {
        //
    },
]);
